import LoaderButton from "@app/components/loader-button.tsx";
import PageTitle from "@app/components/page-title.tsx";
import useConnectData from "@app/data-hooks/use-connect-data.ts";
import { Box, Button, TextField } from "@mui/material";
import { createFileRoute, Link, useNavigate } from "@tanstack/react-router";
import { PasswordField } from "bi-lib";
import { FormEvent, useState } from "react";

interface SearchParams {
    returnUrl?: string;
}

export const Route = createFileRoute("/account/login")({
    validateSearch: (search: Record<string, unknown>): SearchParams => {
        return {
            returnUrl: search.returnUrl as string | undefined,
        };
    },
    component: Component,
});

function Component() {
    const [email, setEmail] = useState<string>();
    const [password, setPassword] = useState<string>();
    const [loading, setLoading] = useState(false);

    const navigate = useNavigate();
    const { returnUrl } = Route.useSearch();

    const { login } = useConnectData();

    const handleLogin = async (e: FormEvent) => {
        e.preventDefault();

        setLoading(true);
        try {
            await login({ username: email!, password: password! });
            void navigate({ to: returnUrl ?? "/entry/time" });
        } finally {
            setLoading(false);
        }
    };

    return (
        <>
            <PageTitle suppressBackButton>Login</PageTitle>
            <form onSubmit={handleLogin}>
                <Box maxWidth={"sm"} margin={"0 auto"} flexDirection={"column"} display={"flex"} gap={2}>
                    <TextField
                        label={"Email"}
                        type={"email"}
                        value={email ?? ""}
                        onChange={(e) => setEmail(e.target.value)}
                        required
                    />
                    <PasswordField label={"Password"} value={password ?? ""} onChange={setPassword} required />
                    <LoaderButton isLoading={loading} type={"submit"} variant={"contained"}>
                        Login
                    </LoaderButton>
                    <Link to={"/account/forgot-password"}>
                        <Button variant={"text"} fullWidth>
                            Forgot Password
                        </Button>
                    </Link>
                </Box>
            </form>
        </>
    );
}
